import { combineLatest, filter, first, Observable, tap, withLatestFrom } from "rxjs";

export function listenForResult(
  loadingStateSelector: any,
  errorStateSelector: any,
  successFunct: Function,
  errorFunct: (error: any) => void = (error: any) => { },
): void {
  loadingStateSelector.pipe(
    filter((loadingState: number) => loadingState === 0),
    first(),
    withLatestFrom(errorStateSelector),
    tap(([_, error]) => {
      if (!!error) {
        errorFunct(error);
      } else {
        successFunct();
      }
    })
  ).subscribe()
}

/**
 * A multi-state listener version of listenForResult. Should be used when dispatching to multiple different state slices.
 * @param loadingStateSelectors The loading states
 * @param errorStateSelectors The error states
 * @param onSuccess The callback function on a success for all states.
 * @param onError The callback function on an error in any state.
 */
export function listenForMultipleResults(
  loadingStateSelectors: Array<Observable<number>>,
  errorStateSelectors: Array<Observable<any>>,
  onSuccess: () => void,
  onError: (error: any) => void
): void {
  combineLatest(loadingStateSelectors).pipe(
    filter(loadingStateSelectors => loadingStateSelectors.every(state => state === 0)),
    first(),
    withLatestFrom(combineLatest(errorStateSelectors)),
    tap(([_, errors]) => {
      const error = errors.find(err => !!err);
      if (error) {
        onError(error);
      } else {
        onSuccess();
      }
    })
  ).subscribe();
}
